import types from 'constants/actionTypes';

const initialState = null;

const selectedOptions = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (type) {
    case types.SET_SELECTED_OPTIONS:
      return payload;
    default:
      return state;
  }
};

export default selectedOptions;
